import DownloadHODL from './DownloadHODL.jsx';

export default DownloadHODL;